export default {
  downtimeUrl: "https://cl.kodland.tech",
  startPage: {
    image: {
      url: "/welcome/es_freecourse_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: "/welcome/es_freecourse_mob.png",
    title:
      "¡Regístrate ahora y obtén un curso de programación gratuito para tu hijo/a!",
    subtitle:
      "🎁 Recibirás 3 lecciones interactivas gratuitas para que tu hijo/a pruebe programación en un formato práctico y divertido<br><br>📲 Te enviaremos el acceso por WhatsApp y email",
    button: "Obtener el curso 🚀",
  },
  parameters: {
    landing_id: "LatQFC",
    success_page: "success_longV3",
  },
  successPage: {
    title: "¡Felicitaciones! 🎁",
    subtitle:
      "Haz clic en el botón para elegir la hora y fecha de tu sesión premium en línea con un tutor. ¡Los cupos son limitados! Completa el registro para recibir tus lecciones interactivas gratuitas por correo electrónico y WhatsApp.",
    button: "📆 Completar el registro",
  },
  stopPage: {
    image: "/welcome/quiz_stop_page.jpg",
    title:
      "¡Gracias por confiar en nuestra plataforma educativa! Desafortunadamente, las tabletas o los teléfonos no son adecuados para tomar nuestras lecciones. ¡Estaremos felices de verlos en nuestras aulas la próxima vez!",
  },
  quizRotateBySteps: {
    1: {
      question:
        "¿Te gustaría que el tiempo que tu hijo/a pasa en la computadora fuera más productivo?",
      answers: [
        "🔥 ¡Si!",
        "🤗 No. Lo hace solo para divertirse y eso está bien",
      ],
    },
    2: {
      question:
        "¿Cuáles son las habilidades de tu hijo/a con la computadora/portátil?",
      answers: [
        "👍 No tiene conocimientos, debe estudiar lo básico",
        "🙌 Nivel básico, sabe usar Power Point y otras aplicaciones",
        "🖥 Nivel intermedio, quiere profundizar conocimientos",
        "🕹 Usa los dispositivos más que nada para juegos",
      ],
    },
    3: {
      question:
        "En estos momentos, ¿Que es lo más importante para ti en el desarrollo de tu hijo/a?",
      answers: [
        "🤔 Habilidades blandas",
        "🎓 Preparación para una carrera a futuro",
        "🖥 Actividades extracurriculares",
      ],
    },
    4: {
      question:
        "¿Tienes una computadora de escritorio/portátil donde puedas trabajar?",
      answers: [
        "💻 Sí",
        {
          answer: "😐 No",
          stopAnswer: true,
        },
      ],
    },
  },
};
